import { Temporal } from "@pima/utils";
import { ParseResult } from "effect";
import * as S from "effect/Schema";
/**
 * Calendar-date wire form for a date-only filter param: ISO `YYYY-MM-DD` on
 * the wire, `Temporal.PlainDate` once decoded — never a JS `Date`. A
 * malformed string fails the schema at the boundary rather than reaching
 * the query builder.
 */
export const PlainDateFromString = S.transformOrFail(S.String, S.declare((u) => u instanceof Temporal.PlainDate, { identifier: "Temporal.PlainDate" }), {
    strict: true,
    decode: (s, _, ast) => ParseResult.try({
        try: () => Temporal.PlainDate.from(s),
        catch: (cause) => new ParseResult.Type(ast, s, String(cause)),
    }),
    encode: (d) => ParseResult.succeed(d.toString()),
});
/**
 * Instant-in-time wire form for a `date_updated`-style watermark filter: ISO
 * timestamp on the wire, `Temporal.Instant` once decoded. A malformed string
 * fails the schema at the boundary rather than reaching the query builder.
 */
export const InstantFromString = S.transformOrFail(S.String, S.declare((u) => u instanceof Temporal.Instant, { identifier: "Temporal.Instant" }), {
    strict: true,
    decode: (s, _, ast) => ParseResult.try({
        try: () => Temporal.Instant.from(s),
        catch: (cause) => new ParseResult.Type(ast, s, String(cause)),
    }),
    encode: (d) => ParseResult.succeed(d.toString()),
});
/**
 * A calendar date field: `YYYY-MM-DD` on the wire, `Temporal.PlainDate` once
 * decoded. It composes the refinement below with {@link PlainDateFromString},
 * so there is one conversion and the refinement only narrows the text.
 * `PlainDate.from` alone also accepts text that carries a time (it drops it);
 * a timestamp, another spelling or an impossible day is not a calendar date.
 */
export const CalendarDateFromString = S.compose(S.String.pipe(S.filter((text) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(text))
        return false;
    try {
        Temporal.PlainDate.from(text, { overflow: "reject" });
        return true;
    }
    catch {
        return false;
    }
}, {
    identifier: "CalendarDate",
    message: () => "expected a calendar date as YYYY-MM-DD",
})), PlainDateFromString);
//# sourceMappingURL=temporal.js.map